import { V1_THROW_ERROR } from '../../actions/errors/v1throwError'

const initialState = {
  message: null,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_THROW_ERROR:
      return {
        ...state,
        message: action.data.message,
      }
    default:
      return state
  }
}
